import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import I18n from '~/src/common/services/I18n';

import * as S from '../layout';
import TrustscoreWidget from '../TrustscoreWidget';
import { sendFooterNavigationEvent } from '../utils';

const RatingsAndDownloadAppsSection = () => {
  const isTrustpilotEnabled = useFeatureFlag('widgets-trustpilot');

  return (
    <div>
      <S.SectionTitle>
        {I18n.t(isTrustpilotEnabled ? 'footer.ratings-and-download' : 'footer.download-apps')}
      </S.SectionTitle>
      <S.AppsBadgesContainer>
        <S.StoreApps>
          <S.AppStore
            onClick={() => {
              sendFooterNavigationEvent('app store');
            }}
          />

          <S.GooglePlay
            onClick={() => {
              sendFooterNavigationEvent('play store');
            }}
          />
        </S.StoreApps>

        {isTrustpilotEnabled ? <TrustscoreWidget /> : null}
      </S.AppsBadgesContainer>
    </div>
  );
};

export default RatingsAndDownloadAppsSection;
